/**
 * Formats a subSkill string into a readable title.
 * Example: 'breuken_vergelijken' -> 'Breuken Vergelijken'
 * Example: 'omtrek' -> 'Omtrek'
 */
export function formatSubSkill(subSkill: string): string {
  if (!subSkill) return ''

  // Replace underscores and hyphens with spaces
  const withSpaces = subSkill.replace(/[_-]/g, ' ')

  // Capitalize first letter of each word
  return withSpaces
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}
